import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useValuesChartsDataContext } from './hooks/useValuesChartsDataContext';

export const TransferValueComparisonPercentualAnual = () => {
    const { chartData } = useValuesChartsDataContext();

    return (
        <SimpleBars
            title={'Comparação do Valor de Repasse - Percentual (Anual)'}
            horizontal={false}
            subtitles={chartData?.transferValueComparisonPercentualAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.transferValueComparisonPercentualAnual?.map((item) => `${Number(item?.percentage || 0).toFixed(2)}%`)}
        />
    );
};
